export class UserTokenModel {
    ClientID = '';
    ClientSecret = '';
}
